import { TSESTree } from '@typescript-eslint/types';
import { ColumnTypeEnum } from '@y42/json-schema';

export class FunctionsBinModel {
  constructor(
    public target = '',
    public elseCase = '',
    public parameters: FunctionParameterModel[] = [new FunctionParameterModel()],
    public name = '',
    public elseCaseFunctionTree: TSESTree.Program | null = null,
    public outputType: string = ColumnTypeEnum.String,
  ) {}
}

export class FunctionParameterModel {
  constructor(
    public name = '',
    public filterString = '',
    public filterFunctionTree: TSESTree.Program | null = null,
    public nameFunctionTree: TSESTree.Program | null = null,
  ) {}
}
